import { useCallback } from 'react';
import { useMutation } from '@apollo/client/react/hooks';
import { UpdateKitchenDisplayInput } from '@oolio-group/domain';
import { analyticsService } from '../analytics/AnalyticsService';
import { UPDATE_KITCHEN_DISPLAY } from '../graphql/kitchenDisplay';
import { noopHandler } from '../utils/general';
import { useSession } from './useSession';

// Saves the devices or sections the user picked to this display. The session updates after the save.
export function useDocketFilterSelection() {
  const { session, setSession } = useSession();
  const kitchenDisplayId = session?.kitchenDisplay?.id;

  // The session only changes once the server has saved the selection.
  const [updateKitchenDisplay, { loading }] = useMutation(
    UPDATE_KITCHEN_DISPLAY,
    {
      onCompleted: data =>
        setSession({ kitchenDisplay: data.updateKitchenDisplay }),
      onError: noopHandler,
    },
  );

  const saveSelection = useCallback(
    (field: 'devices' | 'sections', ids: string[]) => {
      if (!kitchenDisplayId) {
        return;
      }
      analyticsService.capture('Changed Order Filter');
      const input: UpdateKitchenDisplayInput = {
        id: kitchenDisplayId,
        [field]: ids,
      };
      updateKitchenDisplay({ variables: { input } });
    },
    [kitchenDisplayId, updateKitchenDisplay],
  );

  return { saveSelection, loading };
}
